import { render, staticRenderFns } from "./ConfirmAdd_Purchase.vue?vue&type=template&id=5673a65a&scoped=true&"
import script from "./ConfirmAdd_Purchase.vue?vue&type=script&lang=js&"
export * from "./ConfirmAdd_Purchase.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAdd_Purchase.vue?vue&type=style&index=0&id=5673a65a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673a65a",
  null
  
)

export default component.exports